// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2WAtm","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1xhPK","gfeWrapper":"CalendarEvent_gfeWrapper__1D6W_"};